import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { ICON_CANCEL, ICON_SAVE } from '../../extras/icons';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { savePersonTypesAction, updatePersonTypesAction } from '../../../actions/personTypesActions';

import ButtonSpinner from '../../layout/ButtonSpinner';
import formikLocale from '../../../constants/formikLocale';
//Función principal
const PersonTypeForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const personTypesLoading = useSelector( state => state.personTypes.loadingSave );
    const errorSave = useSelector( state => state.personTypes.errorSave );
    const isEdit = useSelector( state => state.personTypes.isEdit );
    const personTypeSelected = useSelector( state => state.personTypes.personTypeSelected );
    //Inicializo el state local
    const [ personType, setPersonType ] = useState(initialData);
    const [ error, setError ] = useState(null);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && personTypeSelected){
            setPersonType(personTypeSelected);
        }else{
            setPersonType(initialData);
        }
    }, [isEdit, personTypeSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setPersonType({
            ...personType,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...personType
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico operación
        if(personType.id){
            //Es edición
            dispatch( updatePersonTypesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( savePersonTypesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setPersonType(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Persona Tipo&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...personType }}
                onSubmit={values => handleSave(values)}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="description">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ personTypesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                personTypesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ personTypesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ personTypesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default PersonTypeForm;